import { Button, Col, Steps } from "antd";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import ProjectDetails from "./ProjectDetails";
import ProjectLead from "./ProjectLead";
import Organisations from "./Organisations";
import ParticipantsRoles from "./ParticipantsRoles";
import TargetBeneficiaries from "./TargetBeneficiaries";
import { citizenScienceStatusEnum, openNotification } from "@seims/shared";
import { Messages, Notify } from "../../services/custom/Messages";
import util from "../../utils/functions/custom";
import api from "src/services/citizenscienceService";
import { recordError } from "@seims/shared/src/utils/logService";
import "./citizenScience.css";

export default function CitizenScienceHome() {
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [saveText, setSaveText] = useState("Submit");
  const formRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [selectedOrganization, setSelectedOrganization] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [otherBeneficiary, setOtherBeneficiary] = useState(null);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: undefined,
    firstname: "",
    surname: "",
    contact: "",
    email: "",
    hasError: false,
    beneficiary: undefined,
  });
  // const [citiData, setCitiData] = useState({ ...citizenObject });
  const [citiData, setCitiData] = useState({});
  const [hideButtons, setHideButtons] = useState(false);

  useEffect(() => {
    reloadData();
  }, [current, formData, selectedOrganization, beneficiaries]);

  const reloadData = () => {
    console.log("current state is ", current, citizenScienceStatusEnum);

    if (
      !util.isEmpty(formData) &&
      current === parseInt(citizenScienceStatusEnum.BENEFICIARY)
    ) {
      const organizationEntries = selectedOrganization?.map((entry) => ({
        id: entry.id,
        contributions: entry?.contributions?.map((c) => parseInt(c.value)),
        otherContribution: entry?.otherContribution || null,
      }));
      const locationEntries = formData?.location.map((entry) => ({
        district: entry.district.key,
        province: entry.province.key,
        town: entry.town?.key ?? 0,
      }));


      setCitiData({
        ...citiData,
        name: formData.projectTitle,
        scienceField: formData.scienceFields?.key,
        scienceDomains: formData.scienceDomain,
        researchMethodologies: formData.researchMethodologies,
        locations: locationEntries,
        description: formData.description,
        initiallyCitizenScience: formData.citizenScience,
        objectives: formData.objectives,
        otherObjectives: formData.otherObjective || null,
        startDate: formData.startDate,
        endDate: formData.endDate,
        lastModified: new Date().toUTCString(),
        dissemination: formData.approach,
        otherDissemination: formData.otherDissemination || null,
        rolesDuringProject: participants.duringProject,
        rolesPreProject: participants.conceptualisation,
        rolesPostProject: participants.postProject,
        contributionRecognition: participants.roles,
        otherRecognition: participants.otherRecognition || null,
        otherDuringRole: participants.otherRoleDuringProject || null,
        otherPostRole: participants.otherRoleAfterProject || null,
        organisationContributions: organizationEntries,
        beneficiaries: beneficiaries,
        otherBeneficiary: formData.otherBeneficiary || null,
        scienceShopInitiative: formData.scishop,
        projectLead: {
          title: formData.title?.key,
          contactNumber: formData.contact,
        },
      });
    }
  };

  const onStatusChange = (direction) => {
    console.log(
      "formRefs ",
      current,
      formRefs[current]?.current?.getFieldsValue()
    );

    const step = direction === "next" ? 1 : -1;
    formRefs[current]?.current
      ?.validateFields()
      .then(() => {
        // formRefs.current.submit();

        if (current === parseInt(citizenScienceStatusEnum.PROJECT_LEAD)) {
          const { title, firstname, surname, contact, email } =
            formRefs[current]?.current?.getFieldsValue();

          setFormData({
            ...formData,
            title: title,
            firstname: firstname,
            surname: surname,
            contact: contact,
            email: email,
          });

          setCurrent(current + step);
        } else if (
          current === parseInt(citizenScienceStatusEnum.PROJECT_DETAILS)
        ) {
          const {
            projectTitle,
            scienceFields,
            scienceDomain,
            researchMethodologies,
            startDate,
            endDate,
            lastModified,
            location,
            description,
            citizenScience,
            objectives,
            approach,
            scishop,
            otherObjective,
            otherDissemination,
          } = formRefs[current]?.current?.getFieldsValue();

          setFormData({
            ...formData,
            projectTitle: projectTitle,
            scienceFields: scienceFields,
            scienceDomain: scienceDomain,
            researchMethodologies: researchMethodologies,
            startDate: startDate, //moment(startDate).toISOString(),
            endDate: endDate, //moment(endDate).toISOString(),
            lastModified: lastModified, // moment().toISOString(),
            location: location,
            description: description,
            citizenScience: citizenScience,
            objectives: objectives,
            approach: approach,
            scishop: scishop,
            otherObjective: otherObjective,
            otherDissemination: otherDissemination,
          });

          const uniqueLocations = location.filter((o, index, arr) =>
            arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
          );
    
          if (uniqueLocations.length < location.length) {
            const msg = "Duplicate locations found, please add unique locations";
            openNotification("Project Location", msg, Notify.ERROR);
            return;
          }
          
          setCurrent(current + step);
        } else if (
          current === parseInt(citizenScienceStatusEnum.ORGANIZATIONS)
        ) {
          const expectedContributions = ["funding", "host organisation"];
          let userSelectedContribs = [];
          let matchingContribs = [];
          let hasEmptyContributions = false;

          //Get all contributions
          selectedOrganization?.forEach((item) => {
            // NOTE: if there are no contribution, record a message
            if (!item?.contributions) {
              hasEmptyContributions = true;
              openNotification(
                "Missing contributions",
                `${item.name} - ${item.address}, ${item.type}: is missing contributions, could you try to add again`,
                Notify.WARNING
              );

              console.error(
                `Missing contributions: ${item.name} - ${item.address}, ${item.type}: is missing contributions.`
              );
            }
            item?.contributions?.forEach((contribute) => {
              userSelectedContribs.push(contribute.label);
            });
          });

          //? This ensures that whenever there are no more contributors then user will not be able to continue to the next screen
          //? However this is discouraged because a user could be stuck on partner screen, so it's better just to display a message
          //? uncomment line below to force the user to stay on the same partner screen and fix the problem with contributions
          if (hasEmptyContributions) {
            return;
          }

          userSelectedContribs?.forEach((contrib) => {
            const newContrib = contrib?.toString().toLowerCase();
            if (expectedContributions.includes(newContrib)) {
              matchingContribs.push(newContrib);
            }
          });

          if (selectedRowKeys.length < selectedOrganization.length) {
            //! This was causing a bug, however this is supposed to be addressed at the OrganizationList level
            // const updatedSelectedOrgs = selectedOrganization.filter((c) =>
            //   selectedRowKeys.includes(c.id)
            // );

            setSelectedOrganization(selectedOrganization);
          }

          if (!matchingContribs.includes("funding")) {
            return openNotification(
              "Key contributions missing",
              "Must specifiy at least one partner with Funding contribution",
              Notify.ERROR
            );
          }
          if (!matchingContribs.includes("host organisation")) {
            return openNotification(
              "Key contributions missing",
              "Must specifiy at least one partner with Host Organisation",
              Notify.ERROR
            );
          }
          if (matchingContribs.length < 2) {
            return openNotification(
              "Key contributions missing",
              "Must specifiy which partner(s) will provide Funding and Host contributions",
              Notify.ERROR
            );
          } else {
            setCurrent(current + step);
          }

          setFormData({
            ...formData,
            organisationContributions: {
              id: 0,
              contributions: [0],
              otherContribution: null,
            },
          });
        } else if (
          current === parseInt(citizenScienceStatusEnum.PARTICIPANTS)
        ) {
          const { duringProject, postProject, otherRole } =
            formRefs[current]?.current?.getFieldsValue();

          setCurrent(current + step);
        }

        setCitiData({ ...citiData, formData });

        // console.log("DATA", title, firstname, );
        // setCurrent(current + step);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });

    // This is temporary solution for empty forms such as organizations
    if (
      formRefs[current]?.current === null ||
      formRefs[current]?.current === undefined
    ) {
      setCurrent(current + step);
      return;
    }
  };

  const handleSelectedOrgs = (orgs) => {
    setSelectedRowKeys(orgs);
  };

  const handleHideButtons = (value) => {
    setHideButtons(value);
  };

  const submitForm = async () => {
    var action = "Submitting Project";
    const entity = "Citizen science project";
    const ben = formRefs.current.getFieldsValue();
    let hasEmptyContributions = false;
    console.log("ben ", ben);
    var msg;
    try {
      // const { beneficiarySelected, otherBeneficiary } =
      // formRefs[current]?.current?.getFieldsValue(["beneficiary"]);
      setLoading(true);
      setSaveText("Submitting...");
      await formRefs.current.validateFields();
      await formRefs.current?.submit();

      // console.log("Form values:", beneficiarySelected["beneficiary"], beneficiary);

      if (ben.beneficiary.length > 0) {
        setFormData({
          ...formData,
          beneficiary: ben.beneficiary,
          otherBeneficiary: ben.otherBeneficiary || null,
        });

        setCitiData({
          // ...citiData,
          name: formData.projectTitle,
          scienceField: formData.scienceFields.key,
          // scienceDomain: formData.scienceDomain,
          scienceDomains: formData.scienceDomain,
          researchMethodologies: formData.researchMethodologies,
          // locations: locationEntries,
          description: formData.description,
          initiallyCitizenScience: formData.citizenScience,
          objectives: formData.objectives,
          otherObjectives: formData.otherObjective || null,
          dissemination: formData.approach,
          startDate: formData.startDate,
          endDate: formData.endDate,
          lastModified: formData.lastModified,
          otherDissemination: formData.otherDissemination || null,
          rolesDuringProject: participants.duringProject || [513], //! 513 is just for testing since BE not handling the empty role at the moment
          rolesPostProject: participants.postProject || [516], //! 516 is just for testing since BE not handling the empty role at the moment
          contributionRecognition: participants.roles,
          otherRecognition: participants.otherRecognition || null,
          otherDuringRole: participants.otherRoleDuringProject || null,
          otherPostRole: participants.otherRoleAfterProject || null,
          // organisationContributions: organizationEntries,
          beneficiaries: ben.beneficiary,
          otherBeneficiary: ben.otherBeneficiary || null,
          scienceShopInitiative: formData.scishop,
          projectLead: {
            title: formData.title.key,
            contact: formData.contact,
          },
        });

        const response = await api.saveSciProject(citiData);
        if (response && (response.status === 201 || response.status === 200)) {
          setLoading(false);
          setSaveText("Done");

          const msg = util.parseMessage(Messages.ADD_SUCCESS, entity);
          openNotification(action, msg, Notify.SUCCESS);
          let path = `/my-projects`;
          navigate(path);
        }
      }
    } catch (error) {
      setLoading(false);
      setSaveText("Done");

      if (
        error.values?.beneficiary === undefined &&
        ben.beneficiary.length === 0
      ) {
        msg = util.parseMessage(Messages.ADD_FAILURE, entity);
        openNotification(
          "Citizen science",
          "Please specify at least 1 beneficiary",
          Notify.ERROR
        );

        return;
      }

      if (
        error &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        msg =
          "An error occurred while submitting the project, please verify if all fields are populated";
        const results = error.response;

        if (results?.message) {
          msg = results?.message;
        }

        openNotification(action, msg, Notify.ERROR);
        recordError(error);
        return;
      }

      console.error("Validation Failed:", error);
      msg = util.parseMessage(Messages.ADD_FAILURE, entity);
      openNotification("Citizen science", msg, Notify.ERROR);
      recordError(error);
    }
  };

  const prev = (status) => {
    const values = formRefs;
    console.log("previous: ", current, formRefs[current]?.current?.getFieldsValue());
    setCurrent(current - 1);
  };

  const handleSelectedOrganization = (selectedOrg) => {
    setSelectedOrganization((prevSelection) => {
      // if organization does not have contributions then remove it altogether
      if (!prevSelection?.contributions && selectedOrg.length === 0) {
        return [];
      }

      // cater for invalid obejcts which are not array as expected
      if (!Array.isArray(prevSelection)) {
        return [selectedOrg];
      }

      // if user unselects or if orgs are empty then just retrun an empty object
      if (selectedOrg?.length === 0) {
        return [];
      }

      let orgIndex = 0;
      let Ids = [];

      if (Array.isArray(selectedOrg)) {
        // flatten tha array in order to ease saving to backend
        Ids = selectedOrg?.map((x) => x.id);
        orgIndex = prevSelection.findIndex((org) => Ids.includes(org.id));
      } else {
        orgIndex = prevSelection.findIndex((org) => org.id === selectedOrg.id);
      }

      if (orgIndex === -1) {
        return [...prevSelection, selectedOrg];
      } else {
        // Update the existing organization contributions

        const updatedSelection = prevSelection.map((org, index) => {
          // Cases where the organization has not changed, only update floating info like otherContributions
          if (index === orgIndex) {
            org.otherContribution = selectedOrg.otherContribution;
            org.contributions = selectedOrg.contributions;
            return {
              ...org,
              contributions: selectedOrg.contributions,
            };
          }
          return org;
        });

        if (Ids.length > 0) {
          if (updatedSelection.length != selectedOrg.length) {
            return updatedSelection.filter((record) => Ids.includes(record.id));
          }
        }

        return updatedSelection;
      }
    });
  };

  const handleSelectedParticipants = (participantList) => {
    if (participantList) {
      const { values: selectedParticipants } = participantList;
      setParticipants(selectedParticipants);
    }
  };

  const handleBeneficiaries = (selectedBenefiary) => {
    setBeneficiaries(selectedBenefiary);
  };

  const handleFormChange = (changedValues, allValues) => {};

  const steps = [
    {
      title: "Project Lead",
      content: (
        <ProjectLead
          // onSetNextStatus={() => onStatusChange("next")}
          formRef={formRefs[citizenScienceStatusEnum.PROJECT_LEAD]}
          formData={formData}
          onHideButtons={handleHideButtons}
        />
      ),
    },
    {
      title: "Project Details",
      content: (
        <ProjectDetails
          // onSetNextStatus={onStatusChange("next")}
          formRef={formRefs[citizenScienceStatusEnum.PROJECT_DETAILS]}
          formData={formData}
          onHideButtons={handleHideButtons}
          onFormValuesChange={handleFormChange}
        />
      ),
    },
    {
      title: "Partner(s)",
      content: (
        <Organisations
          // onSetNextStatus={onStatusChange("next")}
          formRef={formRefs[citizenScienceStatusEnum.ORGANIZATIONS]}
          formData={formData}
          onHideButtons={handleHideButtons}
          onSelectedOrganization={handleSelectedOrganization}
          selectedOrganization={selectedOrganization}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={handleSelectedOrgs}
          setSelectedGlobalOrganization={setSelectedOrganization}
        />
      ),
    },
    {
      title: "Citizen Scientist Roles",
      content: (
        <ParticipantsRoles
          // onSetNextStatus={onStatusChange("next")}
          formRef={formRefs[citizenScienceStatusEnum.PARTICIPANTS]}
          formData={formData}
          onHideButtons={handleHideButtons}
          participants={participants}
          setParticipants={handleSelectedParticipants}
        />
      ),
    },
    {
      title: "Target Beneficiaries",
      content: (
        <TargetBeneficiaries
          onSetNextStatus={submitForm}
          formRef={formRefs}
          formData={formData}
          onHideButtons={handleHideButtons}
          beneficiaries={beneficiaries}
          setBeneficiaries={handleBeneficiaries}
          otherBeneficiary={otherBeneficiary}
          setOtherBeneficiary={setOtherBeneficiary}
        />
      ),
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));
  const contentStyle = {
    lineHeight: "260px",
    textAlign: "center",
    marginTop: 0,
  };

  return (
    <div className="">
      <div className="main-project-card">
        <div className="project-header">
          <Steps current={current} items={items} />
        </div>
        <div style={contentStyle}>{steps[current].content}</div>
        <div
          className="modal-footer-buttons"
          style={{
            marginTop: 24,
            marginRight: 145,
            marginBottom: 40
          }}
        >
          {current > 0 && (
            <Button
              style={{
                margin: "5px 8px",
              }}
              onClick={() => onStatusChange("prev")}
              disabled={hideButtons}
            >
              Previous Step
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => submitForm()}
              disabled={hideButtons}
              style={{
                margin: "5px 8px",
              }}
              loading={loading}
            >
              {saveText}
            </Button>
          )}

          {current < steps.length - 1 && (
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => onStatusChange("next")}
              disabled={hideButtons}
              style={{
                margin: "5px 8px",
              }}
            >
              Next Step
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
